__turbopack_context__.v({
  "active": "work-loyalty-bonus-module-scss-module__vDo0Wa__active",
  "badge": "work-loyalty-bonus-module-scss-module__vDo0Wa__badge",
  "message": "work-loyalty-bonus-module-scss-module__vDo0Wa__message",
  "u-animation-bounce": "work-loyalty-bonus-module-scss-module__vDo0Wa__u-animation-bounce",
});
